/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const TickerUp: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M7.99997 1.5C8.28342 1.5 8.55349 1.62038 8.74313 1.83105L13.2431 6.83105C13.6126 7.24155 13.5794 7.8737 13.1689 8.24316C12.7584 8.61259 12.1263 8.5794 11.7568 8.16895L8.99997 5.10645V14.5C8.99997 15.0523 8.55225 15.5 7.99997 15.5C7.4477 15.5 6.99997 15.0523 6.99997 14.5V5.10645L4.24313 8.16895L4.17087 8.24121C3.79547 8.5818 3.21589 8.58955 2.83102 8.24316C2.44614 7.8967 2.39285 7.31922 2.69235 6.91016L2.7568 6.83105L7.2568 1.83105C7.44644 1.62038 7.71652 1.50001 7.99997 1.5Z'
      fill='currentColor'
    />
  </React.Fragment>
)
